@if(print && filter) {
<app-print-filter-data [filter]="filter" />
} @if(data.length){
<div class="card wordcloud">
  <div class="card-header">
    <p class="title">{{ title }}</p>
    <p>{{ count }} respostas</p>

    <hr />
  </div>

  <app-word-cloud
    [data]="dataChart"
    (onClickEvent)="openModal($event)"
    [wWidth]="print ? 700 : null"
    [hHeight]="print ? 250 : null"
  />

  <div class="word-table">
    <app-word-table
      [data]="data"
      [count]="count"
      (onClickEvent)="openModal($event)"
    />
  </div>
</div>
} @else {
<div class="empty">
  <p>Não há dados para exibir</p>
</div>
}
